import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const Button = ({ text, onSubmit, isInverted }) => {
  return (
    <Button.StyledButton onClick={onSubmit} isInverted={isInverted}>
      {text}
    </Button.StyledButton>
  );
};

Button.StyledButton = styled.button`
  height: 46px;
  width: 289px;
  max-width: 289px;
  background-color: ${(props) =>
    props.isInverted ? COLORS.secondaryButtonBackground : COLORS.primaryButtonBackground};
  color: ${(props) => (props.isInverted ? COLORS.secondaryButtonText : COLORS.primaryButtonText)};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  font-family: ${FONTS.default};
  margin-top: ${(props) => (props.isInverted ? '16px' : '32px')};
  cursor: pointer;
  border: ${(props) =>
    props.isInverted ? `1px solid ${COLORS.secondaryButtonBackground}` : 'none'};;

  &:hover {
    background-color: ${(props) =>
      props.isInverted
        ? COLORS.secondaryButtonHoverBackground
        : COLORS.primaryButtonHoverBackground};
    border: ${(props) => (props.isInverted ? `1px solid ${COLORS.secondaryButtonBorder}` : 'none')};
    color: ${(props) => (props.isInverted ? COLORS.secondaryButtonText : COLORS.primaryButtonText)};
  }

  &:focus {
    outline: none;
  },
`;

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  isInverted: PropTypes.bool,
};

export default Button;
